{
  "shellSkipMenuMainContent": "メインコンテンツにスキップ"
}
